import { faPen, faRedo } from '@fortawesome/free-solid-svg-icons';
import IconButton from 'components/common/IconButton';
import { hasPermissionWithPath } from 'helpers/permissionHelper';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

/* DashboardViewControls component
 * This component renders a set of controls for viewing a dashboard.  
 * It includes buttons for switching to edit mode and refreshing the dashboard. */
export default function DashboardViewControls({ dashboardId, onEditClick, onRefreshClick, autoRefreshInterval, onAutoRefreshIntervalChange }) {
  return (
    <Col md="auto" className="mb-3 mb-md-0">
      <Row className="g-3 gy-md-0 h-100 align-items-center">
        <Col xs="auto">
          {hasPermissionWithPath(`/dashboard/edit/${dashboardId}`) ? <IconButton
            size="sm"
            variant="falcon-primary"
            iconClassName="me-2"
            icon={faPen}
            onClick={onEditClick}
          >
            Switch to Edit
          </IconButton> : <></>}

        </Col>
        <Col xs="auto">
          <IconButton
            size="sm"
            variant="falcon-primary"
            iconClassName="me-2"
            icon={faRedo}
            onClick={onRefreshClick}
          >
            Refresh
          </IconButton>


        </Col>
        <Col xs="auto">
          <Form.Select size="sm" defaultValue="30" value={autoRefreshInterval} onChange={onAutoRefreshIntervalChange}>
            <option value="-1">Never</option>
            <option value="10">10 Secs</option>
            <option value="30">30 Secs</option>
            <option value="60">1 Minute</option>
            <option value="300">5 Minutes</option>
            <option value="600">10 Minutes</option>
          </Form.Select>
        </Col>
      </Row>
    </Col>
  );
}

DashboardViewControls.propTypes = {
  dashboardId: PropTypes.number.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onRefreshClick: PropTypes.func.isRequired,
  autoRefreshInterval: PropTypes.number.isRequired,
  onAutoRefreshIntervalChange: PropTypes.func.isRequired,
};